<div class="sidenav-fixed-toggle"
     [ngClass]="{ 'opened': sidenav.opened, 'show-visual': showToggle }"
     (mouseenter)="onStripEnter()"
     (mouseleave)="onStripLeave()"
     (click)="toggleSidenav()">
  <div class="sidenav-fixed-toggle__visual"
       fxLayout="column" fxLayoutAlign="center center"
       (mouseenter)="onVisualEnter()">
    <mat-icon [svgIcon]="sidenav.opened ? 'icon_arrow_left' : 'icon_arrow_right'">
    </mat-icon>
  </div>
</div>

<div class="sidenav-gutter-visual"
     [ngClass]="{ 'show': gutterHovered && sidenav.opened }"
     fxLayout="column" fxLayoutAlign="center center"
     (mouseenter)="onGutterVisualEnter()"
     (mouseleave)="onGutterLeave()"
     (click)="onGutterClick()">
  <mat-icon svgIcon="icon_arrow_left"></mat-icon>
</div>

<div class="sidenav-gutter"
     *ngIf="sidenav.opened"
     (mouseenter)="onGutterEnter()"
     (mouseleave)="onGutterLeave()"
     (click)="onGutterClick()">
</div>
